import { Box, Card, Typography } from '@mui/material';
import { Close, Lock, LockOpen, Shield } from '@mui/icons-material';
import ButtonComponent from '../../../../components/ButtonComponent';

interface AlarmCentralPartitionCardProps {
  isArmed: boolean;
  account: string;
  name: string;
  isVirtual: boolean;
  onDeletePartition?: () => void;
  onCheckDevices?: () => void;
  onArmOrDisarm: () => void;
  isLoadingArmOrDisarm: boolean;
}

const AlarmCentralPartitionCard = ({
  account,
  isArmed,
  name,
  isVirtual,
  onDeletePartition,
  onCheckDevices,
  onArmOrDisarm,
  isLoadingArmOrDisarm,
}: AlarmCentralPartitionCardProps) => {
  return (
    <Card style={{ border: '1px solid rgb(47, 57, 87)' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          p: 2,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'bold' }}>{name}</Typography>
          <Typography fontSize={13}>Conta {account} </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', mr: 2 }}>
            <Shield color={isArmed ? 'error' : 'success'} sx={{ mr: 0.5 }} />
            <Typography
              color={isArmed ? 'error' : 'success'}
              sx={{ fontWeight: 'bold' }}
            >
              {isArmed ? 'Armada' : 'Desarmada'}
            </Typography>
          </Box>
          {isVirtual && (
            <Close
              fontSize={'small'}
              onClick={() => onDeletePartition && onDeletePartition()}
              sx={{ mb: 0, p: 0, cursor: 'pointer' }}
            />
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          pb: 1,
        }}
      >
        {isVirtual && (
          <ButtonComponent
            variant="outlined"
            size="small"
            onClick={() => onCheckDevices && onCheckDevices()}
          >
            Ver dispositivos vinculados
          </ButtonComponent>
        )}
        <ButtonComponent
          size="small"
          loading={isLoadingArmOrDisarm}
          startIcon={!isArmed ? <Lock /> : <LockOpen />}
          onClick={() => onArmOrDisarm()}
        >
          {isArmed ? 'Desarmar' : 'Armar'}
        </ButtonComponent>
      </Box>
    </Card>
  );
};

export default AlarmCentralPartitionCard;
